define('drops/drawings/start/start',['jquery', 'drops/drawings/businessprocessElement'],
    function ($, BusinessProcessElement) {
    'use strict';

    var defaults = {
        data: {
            size: { x: 40, y: 40 },
            text: '',
            textPosition: 'Right',
            linkToApplication: false
        }
    };

    function Start(options) {
        BusinessProcessElement.call(this, $('<div/>'), defaults, options);
        var self = this;

        self.$text = self.createTextElement();
        self.$textCell = $('<div/>')
            .append(self.$text)
            .addClass('bp-textcell');
        self.$textContainer = $('<div/>')
            .append(self.$textCell)
            .addClass('bp-textcontainer');

        self.$text.addClass('bp-text-' + self.data.textPosition);
        self.$textCell.addClass('bp-textcell-' + self.data.textPosition);
        self.$textContainer.addClass('bp-textcontainer-' + self.data.textPosition);

        var $circle = $('<div/>')
            .addClass('bp-start')
            .addClass('bp-element');

        self.$element
	        .addClass('boxToBorderSize')
            .append(self.$textContainer)
            .append($circle);
    };

    BusinessProcessElement.extend(Start, BusinessProcessElement);

    Start.typeName = 'Start';

    Start.prototype.createTextElement = function () {
        return $('<div/>')
            .text(this.data.text)
            .addClass('bp-text');
    };
        
    Start.prototype.preRender = function () {
        if (!this.editable && this.data.entityId) {
            var self = this;
            this.$element
                .css('cursor', 'pointer')
                .on('click', function () {
                    self.triggerEvent('drawingClicked', self.data.entityId);
                });
        }

        this.applyPosition();
    };

    return Start;
});
